import React from 'react';
import clsx from 'clsx';

import makeStyles from '@material-ui/core/styles/makeStyles';
import { Theme, createStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            padding: '0 0 1rem 0',
            margin: '1rem 0',

            '&.hasLine': {
                borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
            },

            '& h3': {
                fontSize: '1.143rem',
                color: '#212121',
                margin: '0',
                fontWeight: '600',
            },
            '& p': {
                fontSize: '1rem',
                color: '#616161',
                margin: '0.5rem 0 0 0',
                fontWeight: '400',
            },
        },
    }),
);

interface Props {
    title: string;
    subtitle?: string;
    hasLine?: boolean;
}

const FormTitle = (props: Props) => {
    const { title, subtitle } = props;

    const classes = useStyles();

    const classNames = clsx(classes.root, {
        hasLine: props.hasLine,
    });

    return (
        <div className={classNames}>
            <h3>{title}</h3>

            {subtitle && <p>{subtitle}</p>}
        </div>
    );
};

FormTitle.defaultProps = {
    hasLine: false,
} as Partial<Props>;

export default FormTitle;
